<template>
  <div class="game">
    <div v-if="isMobile" class="main-container text--center">
      <div class="game-mobile">
        <img src="/static/img/zombie.png" class="game-mobile__icon" />
        <h1 class="game-mobile__header heading heading--sm">
          Mini DAYZ is not available in the browser mode on smart devices
        </h1>
        <p class="game-mobile__text">
          We have our own app! Download Mini DAYZ here:
        </p>
        <play-buttons class="game-mobile__buttons-wrap" />
        <div class="game-mobile__separator play__separator"></div>
        <router-link :to="{ name: HOME_PAGE_NAME }"
          ><img
            src="/static/img/mdz-logo.png"
            alt="minidayz logo"
            class="game-mobile__logo"
        /></router-link>
      </div>
    </div>
    <div v-else class="main-container">
      <div class="grid">
        <div class="col-12 announcement">
          <span
            >This browser-based version of Mini DAYZ is no longer supported. We
            apologize for any technical issues you might experience. More
            information
            <a
              href="https://minidayz.com/blog/mini-dayz-browser-version-will-no-longer-be-supported"
              >here</a
            >.</span
          >
        </div>
        <div class="col-4_lg-5" data-push-left="off-2_lg-1">
          <a title="Login to play" :href="getLink('sp')" class="js-play">
            <img
              :src="singlePlayerImage"
              alt="Single Player"
              class="img-responsive"
              @mouseenter="singlePlayerImage = singlePlayerHover"
              @mouseleave="singlePlayerImage = singlePlayer"
            />
          </a>
        </div>
        <div class="col-4_lg-5">
          <a title="Login to play" :href="getLink('mp')" class="js-play">
            <img
              :src="multiPlayerImage"
              alt="Multi Player"
              class="img-responsive"
              @mouseenter="multiPlayerImage = multiPlayerHover"
              @mouseleave="multiPlayerImage = multiPlayer"
            />
          </a>
        </div>
      </div>
      <social-widget></social-widget>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { HOME_PAGE_NAME } from "../../router/names";
import PlayButtons from "../partials/common/PlayButtons";
import SocialWidget from "../partials/SocialWidget.vue";

export default {
  components: {
    "social-widget": SocialWidget,
    "play-buttons": PlayButtons
  },
  data() {
    return {
      singlePlayerImage: "/static/img/game/minidayz_sp.png",
      singlePlayer: "/static/img/game/minidayz_sp.png",
      singlePlayerHover: "/static/img/game/minidayz_sp-hover.png",
      multiPlayerImage: "/static/img/game/minidayz_mp.png",
      multiPlayer: "/static/img/game/minidayz_mp.png",
      multiPlayerHover: "/static/img/game/minidayz_mp-hover.png",
      HOME_PAGE_NAME
    };
  },
  metaInfo: {
    title: "Play in Browser"
  },
  computed: {
    ...mapGetters("user", {
      authenticated: "authenticated"
    }),
    isMobile() {
      return this.$store.state.settings.isMobile;
    }
  },
  methods: {
    getLink(entity) {
      if (this.authenticated) {
        return "/play/" + entity + "/index.html";
      } else {
        return "api/auth/login";
      }
    }
  }
};
</script>
<style scoped lang="scss">
.announcement {
  text-align: center;
  margin-bottom: 2em;

  a {
    text-decoration: underline;
  }
}
</style>
